<template>
  <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/')"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      {{ projet.ll_programme }} - {{ groupe.nom_groupe }}
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-card class="ma-2" flat light>
      <v-card-text v-if="user.role != 'operateur'">
        <template>
          <v-expansion-panels
            focusable
            class="elevation-0"
            v-model="openedPanel"
          >
            <v-expansion-panel>
              <v-expansion-panel-header
                >Groupe {{ groupe.nom_groupe }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <!-- start a propos -->
                <v-card flat>
                  <v-card-actions class="ma-0 pa-0">
                    <v-row align="center" justify="center">
                      <v-col cols="12" sm="8" md="6" class="mb-0 pb-0">
                        <div justify="center" align="center">
                          <v-btn
                            color="info"
                            fab
                            small
                            dark
                            class="mx-2 my-0"
                            @click.stop="dialogEditGroupe = true"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-dialog v-model="dialogEditGroupe">
                            <v-card>
                              <v-card-title> Editer le groupe</v-card-title>
                              <v-card-text>
                                <v-form ref="forEditGroup">
                                  <v-text-field
                                    v-model="groupe.nom_groupe"
                                    label="Nom"
                                  ></v-text-field>
                                  <v-text-field
                                    v-model="groupe.president"
                                    label="Président"
                                  ></v-text-field>

                                  <v-col cols="12">
                                    <v-menu
                                      v-model="menu2"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          :value="
                                            computedDateConstitutionFormattedMomentjs
                                          "
                                          label="Date de Constitution"
                                          prepend-icon="mdi-calendar-cursor"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        locale="fr"
                                        v-model="groupe.date_constitution"
                                        no-title
                                        @input="menu2 = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-autocomplete
                                      hint="Districts"
                                      dense
                                      @change="setCommunes()"
                                      :rules="selectRules"
                                      :items="districts"
                                      label="Districts"
                                      return-object
                                      item-text="ll_district"
                                      solo
                                      v-model="districtSelectedObject"
                                      required
                                      ref="district_selected"
                                      :loading="communeLoading"
                                    >
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-autocomplete
                                      hint="Communes"
                                      dense
                                      @change="setFokontanys()"
                                      :rules="selectRules"
                                      :items="communes"
                                      label="Communes"
                                      return-object
                                      item-text="ll_commune"
                                      solo
                                      required
                                      v-model="CommuneSelectedObject"
                                      ref="commune_selected"
                                      :loading="fokontanyLoading"
                                    >
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12">
                                    Fokontany :
                                    {{ FokontanySelectedObject.ll_fokontany }}
                                    <v-autocomplete
                                      hint="Fokontany"
                                      dense
                                      :items="fokontanys"
                                      :rules="selectRules"
                                      label="Fokontany"
                                      item-text="ll_fokontany"
                                      return-object
                                      solo
                                      required
                                      v-model="FokontanySelectedObject"
                                      ref="fokontany_selected"
                                    >
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12">
                                    <v-text-field
                                      dense
                                      v-model="groupe.village"
                                      label="Village"
                                      prepend-icon="mdi-map"
                                      :rules="requis"
                                      required
                                    ></v-text-field>
                                  </v-col>
                                </v-form>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  rounded
                                  color="info"
                                  @click.stop="dialogEditGroupe = false"
                                  >Annuler</v-btn
                                >
                                <v-btn
                                  rounded
                                  :loading="mettreAJourLoading"
                                  color="primary"
                                  @click="updateGroupe"
                                  >Mettre à jour</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <v-btn
                            color="warning"
                            fab
                            small
                            dark
                            class="mx-2 my-0"
                            @click="getLocation()"
                          >
                            <v-icon> mdi-crosshairs-gps</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                  <v-card-text class="my-0 py-0">
                    <v-container class="mt-0 pt-0">
                      <v-row>
                        <!--   <vcol texte="Identifiant" :valeur="groupe.email" /> -->
                        <vcol
                          texte="Latitude enregistrée"
                          :valeur="groupe.latitude"
                        />
                        <vcol
                          texte="Longitude enregistrée"
                          :valeur="groupe.longitude"
                        />
                        <vcol texte="Latitude actuelle" :valeur="latitude" />
                        <vcol texte="Longitude actuelle" :valeur="longitude" />
                        <vcol texte="Président" :valeur="groupe.president" />
                        <vcol texte="Région" :valeur="groupe.ll_region" />
                        <vcol texte="District" :valeur="groupe.ll_district" />
                        <vcol texte="Commune" :valeur="groupe.ll_commune" />
                        <vcol texte="Fokontany" :valeur="groupe.ll_fokontany" />
                        <vcol texte="Village" :valeur="groupe.village" />
                        <vcol
                          texte="Date de constitution"
                          :valeur="groupe.date_constitution"
                        />
                        <vcol
                          v-if="groupe.nombreMembres"
                          texte="Membres actifs"
                          :valeur="groupe.nombreMembres"
                        />
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
                <!-- End a propos -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-card-text>
    </v-card>

    <v-card class="transparent elevation-0 px-0 pb-4">
      <v-card-text class="my-0 py-0">
        <v-btn
          v-if="user.role != 'operateur'"
          block
          class="primary rounded-pill my-4"
          @click.stop="gotoListeMembresDuGroupe(idGroupe)"
          ><v-icon class="mr-4">mdi-account-group</v-icon>Membres</v-btn
        >

        <v-btn
          block
          class="info rounded-pill my-4"
          @click.stop="gotoListeFormationsDuGroupe(idGroupe)"
          ><v-icon class="mr-4">mdi-school</v-icon>Formations
          <span
            v-if="
              user.role != 'regionalFull' || user.role === 'regionalReadOnly'
            "
            ><span v-if="user.role != 'operateur'">(03 mois)</span></span
          >
        </v-btn>
        <v-btn
          block
          class="success rounded-pill my-4"
          @click.stop="gotoListeDotationsDuGroupe(idGroupe)"
          ><v-icon class="mr-4">mdi-tractor-variant</v-icon>Dotations
          <span
            v-if="
              user.role != 'regionalFull' || user.role === 'regionalReadOnly'
            "
            ><span v-if="user.role != 'operateur'">(03 mois)</span></span
          ></v-btn
        >
      </v-card-text>
      <v-card-text class="my-0 py-0">
        <v-btn
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, actual_month)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(actual_month).format("MMM YYYY")
          }})
        </v-btn>

        <v-btn
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, previous_month)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(previous_month).format("MMM YYYY")
          }})
        </v-btn>

        <v-btn
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, previous_month2)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(previous_month2).format("MMM YYYY")
          }})
        </v-btn>
        <v-btn  v-if="
              user.role === 'regionalFull' || user.role === 'regionalReadOnly'
            "
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, previous_month3)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(previous_month3).format("MMM YYYY")
          }})
        </v-btn>
        <v-btn  v-if="
              user.role === 'regionalFull' || user.role === 'regionalReadOnly'
            "
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, previous_month4)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(previous_month4).format("MMM YYYY")
          }})
        </v-btn>
        <v-btn  v-if="
              user.role === 'regionalFull' || user.role === 'regionalReadOnly'
            "
          block
          class="warning rounded-pill my-4"
          @click.stop="gotoListeCampagnesDuGroupe(idGroupe, previous_month5)"
          ><v-icon class="mr-4">mdi-format-list-text</v-icon>Campagnes ({{
            this.$moment(previous_month5).format("MMM YYYY")
          }})
        </v-btn>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.latitude = this.groupe.latitude;
    this.longitude = this.groupe.longitude;
    this.setCommunes();
  },

  data() {
    return {
      districts: [],
      projetmap: null,
      dialogNewProject: false,
      dialogEditGroupe: false,
      locationLoading: false,
      latitude: "null",
      longitude: "null",
      snackbar: false,
      textSnackbar: "Erreur de géolocalisation",
      openedPanel: null,
      menu2: false,
      communes: [],
      fokontanys: [],
      district_selected: "",
      commune_selected: "",
      fokontany_selected: "",
      village: "",
      communeLoading: false,
      fokontanyLoading: false,
      mettreAJourLoading: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],

      showCommunes: true,
      showFokontanys: false,
    };
  },

  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    detailCampagne: require("@/components/groupes/detailCampagne.vue").default,
    dialogNewMembre: require("@/components/groupes/dialogNewMembre.vue")
      .default,
    dialogNewCampagne: require("@/components/groupes/dialogNewCampagne.vue")
      .default,
    dialogNewCycleGec: require("@/components/groupes/dialogNewCycleGec.vue")
      .default,
    dialogNewFormation: require("@/components/groupes/dialogNewFormation.vue")
      .default,
    dialogNewIntrant: require("@/components/groupes/dialogNewIntrant.vue")
      .default,
  },
  props: {
    idGroupe: {
      type: String,
      required: true,
    },
    projet: {
      required: true,
    },
  },

  methods: {
    getInfosAnimateur(idResponsable) {
      let self = this;

      var docRef = self.$firebase
        .firestore()
        .collection("users")
        .doc(idResponsable);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            self.districts = doc.data().districts;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    updateGroupe() {
      const self = this;
      self.mettreAJourLoading = true;
      console.log(this.groupe);
      var ref = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(this.idGroupe);
      var lobjet = {
        nom_groupe: this.groupe.nom_groupe,
        president: this.groupe.president,
        date_constitution: this.groupe.date_constitution,
        code_fokontany: this.groupe.code_fokontany.toString(),
        id_commune: this.groupe.id_commune.toString(),
        id_district: this.groupe.id_district.toString(),

        id_region: this.groupe.id_region.toString(),
        ll_commune: this.groupe.ll_commune,
        ll_district: this.groupe.ll_district,
        ll_fokontany: this.groupe.ll_fokontany,
        ll_region: this.groupe.ll_region,
      };
      var ll_province;
      if (this.groupe.ll_province) {
        lobjet.ll_province = this.groupe.ll_province;
        lobjet.id_province = this.groupe.id_province.toString();
      }

      return ref
        .set(lobjet, { merge: true })
        .then(function () {
          console.log("Groupe successfully updated!");

          /** update membres */
          const MEMBRES = self.$firebase.firestore().collection("membres");
          MEMBRES.where("id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log("membres successfully updated!");
              self.mettreAJourLoading = false;
              self.dialogEditGroupe = false;
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  MEMBRES.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap membres");
              }
            });

          /** END update membres */
          /** update dotationsDeGroupe */
          const dotationsDeGroupe = self.$firebase
            .firestore()
            .collection("dotationsDeGroupe");
          dotationsDeGroupe
            .where("groupes_code_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              if (snapshots.size > 0) {
                console.log("Dotations successfully updated!");
                snapshots.forEach((snap) => {
                  dotationsDeGroupe.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap dotationsDeGroupe");
              }
            });
          /** END update dotationsDeGroupe */
          /** update etapes_effectives */
          const etapes_effectives = self.$firebase
            .firestore()
            .collection("etapes_effectives");
          etapes_effectives
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log("Etapes effectives successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  etapes_effectives.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap etapes_effectives");
              }
            });
          /** End update etapes_effectives */
          /** update formationsDeGroupe */
          const formationsDeGroupe = self.$firebase
            .firestore()
            .collection("formationsDeGroupe");
          formationsDeGroupe
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log("Formations de Groupe successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  formationsDeGroupe.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap formationsDeGroupe");
              }
            });
          /** End update formationsDeGroupe */
          /** update parcours_effectif */
          const parcours_effectif = self.$firebase
            .firestore()
            .collection("parcours_effectif");
          parcours_effectif
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              if (snapshots.size > 0) {
                console.log("Parcours Effectifs successfully updated!");
                snapshots.forEach((snap) => {
                  parcours_effectif.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap parcours_effectif");
              }
            });
          /** End update parcours_effectif */
          /** update presencesFormationsGroupes */
          const presencesFormationsGroupes = self.$firebase
            .firestore()
            .collection("presencesFormationsGroupes");
          presencesFormationsGroupes
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log(
                "Presences Formations De groupe successfully updated!"
              );
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesFormationsGroupes
                    .doc(snap.id)
                    .set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap presencesFormationsGroupes");
              }
            });
          /** End update presencesFormationsGroupes */
          /** update presencesDotationsGroupes */
          const presencesDotationsGroupes = self.$firebase
            .firestore()
            .collection("presencesDotationsGroupes");
          presencesDotationsGroupes
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log("presencesDotationsGroupes successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesDotationsGroupes
                    .doc(snap.id)
                    .set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap presencesDotationsGroupes");
              }
            });
          /** End update presencesFormationsGroupes */
          /** update fiches */
          const fiches = self.$firebase.firestore().collection("fiches");
          fiches
            .where("groupes_id_groupe", "==", self.idGroupe)
            .get()
            .then((snapshots) => {
              console.log("fiches successfully updated!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  fiches.doc(snap.id).set(lobjet, { merge: true });
                });
              } else {
                console.log("no snap fiches");
              }
            });
          /** End update fiches */
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);

          //self.$router.go(0);
        });
    },
    setCommunes() {
      var self = this;
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = true;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = true;
      //getInfosDistrict
      var docRef = this.$firebase
        .firestore()
        .collection("districts")
        //.where("ll_", "==", true)
        .doc(this.districtSelectedObject.id.toString());

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            self.ll_province = doc.data().ll_province;
            self.id_province = doc.data().province_id_province;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such  District!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.districtSelectedObject.id.toString(),
          this.districtSelectedObject.id,
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });

            self.communeLoading = false;
          });
          self.setFokontanys();
        });
    },
    setFokontanys() {
      var self = this;
      this.fokontanys = [];
      this.showFokontanys = true;
      this.new_fokontany = "";
      this.fokontanyLoading = true;
      var query = this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.CommuneSelectedObject.id.toString(),
          this.CommuneSelectedObject.id,
        ]);

      query.get().then(function (snap) {
        if (snap.empty) {
          //console.log("no documents found");
          self.showNewFokontany = true;
          self.showFokontanys = false;
          self.fokontanyLoading = false;
        } else {
          self.showNewFokontany = true;
          self.showFokontanys = true;
          self.fokontanys = [];
          self.fokontanyLoading = false;
          self.fokontanys = [];

          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        }
      });
    },
    getLocation() {
      const self = this;
      this.locationLoading = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.altitude = position.coords.altitude;

          console.log("Mettre à jour les coordonnées du groupe", this.latitude);

          var ref = this.$firebase
            .firestore()
            .collection("groupes")
            .doc(this.idGroupe);

          // update groupe
          return ref
            .update({
              latitude: this.latitude,
              longitude: this.longitude,
              altitude: this.altitude,
            })
            .then(function () {
              console.log("Coordonnées mises à jour");
              //this.SetItemById(this.idGroupe);
              // self.$router.go(0);
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error("Erreur de mise à jour des coordonnées: ", error);
            });
        },
        (err) => {
          this.locationError();
        },
        { timeout: 7000 }
      );
    },
    locationError() {
      console.log("Could not find your location.");
      this.latitude = "-18.880325823505615";
      this.longitude = "47.521450817585";
      this.altitude = "1252";
      this.locationLoading = false;
      this.snackbar = true;
    },
    updateGroupeProjects() {
      console.log(this.groupe.projets);
      console.log(this.idGroupe);
      let listArray = [];
      this.groupe.projets.forEach(function (projet, index) {
        listArray[index] = projet.id_programme;
      });
      const ref = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(this.idGroupe);
      var setWithMerge = ref.update({
        projectList: listArray,
        projets: this.groupe.projets,
      });

      this.dialogNewProject = false;
    },
    gotoListeMembresDuGroupe(groupe) {
      this.$router.push({
        path: `/detailsGroupe/listeMembresDeGroupe/${groupe}`,
        query: { idProjet: this.projet.id },
      });
    },
    gotoListeFormationsDuGroupe(groupe) {
      this.$router.push({
        path: `/detailsGroupe/listeFormationsDeGroupe/${groupe}`,
        query: { idProjet: this.projet.id },
      });
    },
    gotoListeDotationsDuGroupe(groupe) {
      this.$router.push({
        path: `/detailsGroupe/listeDotationsDeGroupe/${groupe}`,
        query: { idProjet: this.projet.id },
      });
    },
    gotoListeCampagnesDuGroupe(groupe, month) {
      this.$router.push({
        path: `/detailsGroupe/listeCampagnesDeGroupe/${groupe}`,
        query: { month: month, idProjet: this.projet.id },
      });
    },

    log(item) {
      console.log(item);
    },
    ...mapActions({
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      SetItemById: "Groupes/SetItemById",
      GetFormationsDeGroupe: "FormationsDeGroupe/GetFormationsDeGroupe",
      GetDotationsDeGroupe: "DotationsDeGroupe/GetDotationsDeGroupe",
      GetParcoursEffectifsDuGroupe:
        "ParcoursEffectif/GetParcoursEffectifsDuGroupe",
    }),
  },
  computed: {
    locationSupported() {
      if ("geolocation" in navigator) return true;
      return false;
    },
    computedDateConstitutionFormattedMomentjs() {
      return this.groupe.date_constitution
        ? this.$moment(this.groupe.date_constitution).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      groupe: (state) => state.Groupes.itemById,
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
      ProjetsDuSuperviseur: (state) => state.Auth.user.projets,
      user: (state) => state.Auth.user,
      actual_month: (state) => state.Utils.actual_month,
      previous_month: (state) => state.Utils.previous_month,
      previous_month2: (state) => state.Utils.previous_month2,
      previous_month3: (state) => state.Utils.previous_month3,
      previous_month4: (state) => state.Utils.previous_month4,
      previous_month5: (state) => state.Utils.previous_month5,
      annee_actuelle: (state) => state.Utils.annee_actuelle,
    }),

    districtSelectedObject: {
      get: function () {
        var lobjet = {
          id_region: this.groupe.id_region,
          ll_region: this.groupe.ll_region,
          ll_district: this.groupe.ll_district,
          province_id_province: this.groupe.id_province,
          id: this.groupe.id_district,
        };
        var ll_province;
        if (this.groupe.ll_province) {
          lobjet.ll_province = this.groupe.ll_province;
        }
        return lobjet;
      },
      set: function (value) {
        console.log("District: ", value);
        this.groupe.id_district = value.id;
        this.groupe.id_region = value.id_region;
        this.groupe.ll_district = value.ll_district;
        this.groupe.ll_province = value.ll_province;
        this.groupe.ll_region = value.ll_region;
        this.groupe.id_province = value.province_id_province;
      },
    },
    CommuneSelectedObject: {
      get: function () {
        var lobjet = {
          id_region: this.groupe.id_region,
          ll_region: this.groupe.ll_region,
          ll_district: this.groupe.ll_district,
          province_id_province: this.groupe.id_province,
          id_district: this.groupe.id_district,
          ll_commune: this.groupe.ll_commune,
          id: this.groupe.id_commune,
        };
        var ll_province;
        if (this.groupe.ll_province) {
          lobjet.ll_province = this.groupe.ll_province;
        }
        return lobjet;
      },
      set: function (value) {
        console.log("Commune: ", value);
        this.groupe.id_district = value.id_district;
        this.groupe.id_commune = value.id;
        this.groupe.ll_commune = value.ll_commune;
      },
    },
    FokontanySelectedObject: {
      get: function () {
        var lobjet = {
          id: this.groupe.code_fokontany,
          id_commune: this.groupe.id_commune,
          id_district: this.groupe.id_district,
          id_region: this.groupe.id_region,
          ll_commune: this.groupe.ll_commune,
          ll_district: this.groupe.ll_district,
          ll_fokontany: this.groupe.ll_fokontany,
          ll_region: this.groupe.ll_region,
        };
        var ll_province;
        if (this.groupe.ll_province) {
          lobjet.ll_province = this.groupe.ll_province;
          lobjet.id_province = this.groupe.id_province;
        }

        return lobjet;
      },
      set: function (value) {
        this.groupe.code_fokontany = value.id;
        this.groupe.id_commune = value.id_commune;
        this.groupe.id_district = value.id_district;
        this.groupe.id_province = value.id_province;
        this.groupe.id_region = value.id_region;
        this.groupe.ll_commune = value.ll_commune;
        this.groupe.ll_district = value.ll_district;
        this.groupe.ll_fokontany = value.ll_fokontany;
        this.groupe.ll_province = value.ll_province;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
